
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_1ljr7_9",
  "scrolling-background": "awsui_scrolling-background_hyvsj_1ljr7_12",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_1ljr7_19",
  "drawers-container": "awsui_drawers-container_hyvsj_1ljr7_24",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_1ljr7_35",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_1ljr7_59",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_1ljr7_64",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_1ljr7_102",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_1ljr7_115",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_1ljr7_120",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_1ljr7_134",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_1ljr7_120",
  "drawer": "awsui_drawer_hyvsj_1ljr7_24",
  "drawer-content-container": "awsui_drawer-content-container_hyvsj_1ljr7_168",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_1ljr7_177",
  "drawer-content": "awsui_drawer-content_hyvsj_1ljr7_168",
  "drawer-content-hidden": "awsui_drawer-content-hidden_hyvsj_1ljr7_186",
  "drawer-slider": "awsui_drawer-slider_hyvsj_1ljr7_189",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_1ljr7_197",
  "content": "awsui_content_hyvsj_1ljr7_219",
  "layout": "awsui_layout_hyvsj_1ljr7_236",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_1ljr7_308",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_1ljr7_323",
  "content-type-table": "awsui_content-type-table_hyvsj_1ljr7_337",
  "content-type-cards": "awsui_content-type-cards_hyvsj_1ljr7_337",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_1ljr7_343",
  "is-hide-mobile-toolbar": "awsui_is-hide-mobile-toolbar_hyvsj_1ljr7_346",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_1ljr7_360",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_1ljr7_363",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_1ljr7_373",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_1ljr7_376",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_1ljr7_376",
  "has-header": "awsui_has-header_hyvsj_1ljr7_376",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_1ljr7_391",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_1ljr7_391",
  "has-left-toggles-gutter": "awsui_has-left-toggles-gutter_hyvsj_1ljr7_411",
  "has-right-toggles-gutter": "awsui_has-right-toggles-gutter_hyvsj_1ljr7_414",
  "has-split-panel": "awsui_has-split-panel_hyvsj_1ljr7_434",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_1ljr7_434",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_1ljr7_442",
  "unfocusable": "awsui_unfocusable_hyvsj_1ljr7_447",
  "container": "awsui_container_hyvsj_1ljr7_453",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_1ljr7_479",
  "is-tools-open": "awsui_is-tools-open_hyvsj_1ljr7_482",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_1ljr7_482",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_1ljr7_482",
  "has-active-drawer": "awsui_has-active-drawer_hyvsj_1ljr7_482",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_1ljr7_487",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_hyvsj_1ljr7_504",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_1ljr7_508",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_1ljr7_512",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_1ljr7_516",
  "navigation-container": "awsui_navigation-container_hyvsj_1ljr7_521",
  "show-navigation": "awsui_show-navigation_hyvsj_1ljr7_559",
  "animating": "awsui_animating_hyvsj_1ljr7_582",
  "showButtons": "awsui_showButtons_hyvsj_1ljr7_1",
  "navigation": "awsui_navigation_hyvsj_1ljr7_521",
  "openNavigation": "awsui_openNavigation_hyvsj_1ljr7_1",
  "animated-content": "awsui_animated-content_hyvsj_1ljr7_646",
  "content-container": "awsui_content-container_hyvsj_1ljr7_649",
  "hide-navigation": "awsui_hide-navigation_hyvsj_1ljr7_658",
  "notifications": "awsui_notifications_hyvsj_1ljr7_664",
  "has-notification-content": "awsui_has-notification-content_hyvsj_1ljr7_669",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_1ljr7_673",
  "high-contrast": "awsui_high-contrast_hyvsj_1ljr7_678",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_1ljr7_692",
  "position-bottom": "awsui_position-bottom_hyvsj_1ljr7_739",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_1ljr7_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_1ljr7_768",
  "position-side": "awsui_position-side_hyvsj_1ljr7_781",
  "tools-container": "awsui_tools-container_hyvsj_1ljr7_799",
  "tools": "awsui_tools_hyvsj_1ljr7_799",
  "openTools": "awsui_openTools_hyvsj_1ljr7_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_1ljr7_891",
  "hide-tools": "awsui_hide-tools_hyvsj_1ljr7_901",
  "show-tools": "awsui_show-tools_hyvsj_1ljr7_913",
  "has-tools-form": "awsui_has-tools-form_hyvsj_1ljr7_891",
  "trigger-button-styles": "awsui_trigger-button-styles_hyvsj_1ljr7_989",
  "trigger-badge-wrapper": "awsui_trigger-badge-wrapper_hyvsj_1ljr7_1005",
  "trigger": "awsui_trigger_hyvsj_1ljr7_989",
  "selected": "awsui_selected_hyvsj_1ljr7_1057",
  "badge": "awsui_badge_hyvsj_1ljr7_1077",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_1ljr7_1081",
  "trigger-wrapper-tooltip-visible": "awsui_trigger-wrapper-tooltip-visible_hyvsj_1ljr7_1092",
  "dot": "awsui_dot_hyvsj_1ljr7_1096",
  "trigger-tooltip": "awsui_trigger-tooltip_hyvsj_1ljr7_1109"
};
  